import { Card, Container } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormUpload from '../SubMerchantActivation/FormUpload';
import { clearRedux, submitActivationBulkGIGR } from './actions';
import RenderModal from './modal';
import styles from './styles.scoped.css';
import { AppContext } from '../../contexts';
import { useNavigate } from 'react-router-dom';

export default function ActivationMerchantBulk() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useContext(AppContext);
  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState('');
  const [afterSubmit, setAfterSubmit] = useState(false);

  useEffect(() => {
    setBreadcrumbs([{
      name: 'Aktivasi Menu GI/GR',
      to: '/gigr-activation'
    }, 'Aktivasi Pangkalan dengan File']);
    dispatch(clearRedux('ActivationBulkGIGR'));
  },[]);

  const {
    dataActivationBulkGIGR, isLoadingActivationBulkGIGR, messageActivationBulkGIGR
  } = useSelector((s) => s.gigrActivation);

  const fileUrl = 'https://storage.googleapis.com/fin-map-images-public-stage/templates/Template_list_RegistrationId.csv';

  const infoUpload = [
    <span key={'info'}>Unduh file CSV <a download href={fileUrl}
      style={{ color: '#5E811E', cursor: 'pointer', fontWeight: 700 }}
    >di sini.</a></span>,
    'Masukan list data pangkalan yang akan diaktivasi',
    'Unggah kembali file yang sudah di isi.'
  ];

  useEffect(() => {
    if (
      afterSubmit &&
        messageActivationBulkGIGR !== '' &&
        messageActivationBulkGIGR !== undefined && dataActivationBulkGIGR === null
    ) {
      setModalMode('failed');
      setOpenModal(true);
    } else if (
      afterSubmit &&
        !isLoadingActivationBulkGIGR &&
        dataActivationBulkGIGR?.data?.failedTotal === 0
    ) {
      setOpenModal(true);
      setModalMode('success');
    } else if (
      afterSubmit &&
        !isLoadingActivationBulkGIGR &&
        dataActivationBulkGIGR?.data?.failedTotal > 0
    ) {
      setOpenModal(true);
      setModalMode('reason');
    }
  }, [dataActivationBulkGIGR, messageActivationBulkGIGR]);

  const _handleSubmit = (data) => {
    dispatch(submitActivationBulkGIGR(data.file, setAfterSubmit(true)));
  };

  const _handleCloseModal = () => {
    setOpenModal(false);
    setAfterSubmit(false);
    setModalMode('');
    dispatch(clearRedux('ActivationBulkGIGR'));
    navigate('/gigr-activation');
  };

  return(
    <Container className={styles.form}>
      <Card className={styles.card} withBorder>
        <FormUpload
          infoUpload={infoUpload}
          isLoading={isLoadingActivationBulkGIGR}
          onBack={'/gigr-activation'}
          onSubmit={_handleSubmit}
          title="Pilih file dengan format .CSV untuk Aktivasi Menu GI/GR di beberapa pangkalan"
        />
      </Card>
      <RenderModal
        data={dataActivationBulkGIGR?.data}
        handleCloseModal={_handleCloseModal}
        message={messageActivationBulkGIGR}
        opened={openModal}
        variant={modalMode}
      />
    </Container>
  );
}
